export const SITE = {
  title: 'Lesson Planner',
  description:
    'Create a lesson plan in no time! Choose the lesson plan format, class details, and learning objectives. Our lesson planning software will generate a lesson plan for you.',
  logo: '/images/logo.png',
  url: 'https://lessonplanner.org',
  type: 'website',
  keywords: [
    'Lesson planning software',
    'Curriculum mapping tool',
    'Classroom management app',
    'Teacher productivity tool',
    'Educational resource organizer',
    'Digital lesson planner',
    'Teacher scheduling software',
    'Student progress tracker',
    'Assessment and grading tool',
    'Classroom collaboration platform',
    'Lesson plan creator',
    'Instructional materials management',
    'Learning management system',
    'Teacher planner app',
    'Subject-specific lesson templates',
    'Differentiated instruction support',
    'Filipino curriculum alignment',
    'Parent-teacher communication tool',
    'Classroom assessment strategies',
    'Interactive whiteboard integration',
    'Attendance tracking system',
    'Filipino language teaching resources',
    'Classroom behavior management',
    'Professional development resources',
    'Lesson plan sharing community',
    'Assessment data analysis',
    'Student engagement strategies',
    'Multimodal learning activities',
    'Formative and summative assessment',
    'Lesson plan customization options',
    'Lesson plan sharing community',
    'Teacher collaboration platform',
    'Lesson plan maker',
    'Lesson plan template',
    'Lesson plan format',
    'Lesson plan example',
    'Lesson plan sample',
    'Lesson plan outline',
    'Lesson plan for teachers',
    'Lesson plan for elementary',
    'Lesson plan for high school',
    'Lesson plan for kindergarten',
    'Lesson plan for preschool',
    'Lesson plan for grade 1',
    'Lesson plan for grade 2',
    'Lesson plan for grade 3',
    'Lesson plan for grade 4',
    'Lesson plan for grade 5',
    'Lesson plan for grade 6',
    'Lesson plan for grade 7',
    'Lesson plan for grade 8',
    'Lesson planner for teachers',
    'Lesson planner for elementary',
    'Lesson planner for high school',
    'Lesson planner for kindergarten',
    'Lesson planner for preschool',
    'Lesson Plan',
    'Teacher Planner',
    'Lesson Planner',
    'Lesson Planning',
    'Comprehensive Lesson Plan',
    'Detailed Lesson Plan',
    'Semi-Detailed Lesson Plan',
    'Daily Lesson Log',
    'Weekly Lesson Log',
    'Professional Lesson Plan',
    'Master Teacher Lesson Plan',
    'IB lesson planner',
    'International Baccalaureate lesson plans',
    'PYP lesson planning',
    'MYP unit planner',
    'DP lesson templates',
    'IB curriculum planning',
    'IB unit planner',
    'IB assessment planner',
    'IB learner profile activities',
    'ATL skills planning',
    'CAS activity planner',
    'TOK lesson planning',
    'Extended essay planning',
    'IB approaches to teaching',
    'IB approaches to learning',
    'Primary Years Programme planning',
    'Middle Years Programme units',
    'Diploma Programme resources',
    'IB Career-related Programme',
    'International Baccalaureate teaching',
    'IB inquiry planning',
    'IB conceptual understanding',
    'IB transdisciplinary themes',
    'IB global contexts',
    'IB statement of inquiry',
    'IB differentiated instruction',
    'International teaching strategies',
    'IB formative assessment',
    'IB summative assessment',
    'Inquiry-based learning plans',
    'International curriculum mapping',
    'IB backward planning',
    'IB unit planning',
    'International learning objectives',
    'Global competency planning',
    'IB PYP lesson plans',
    'IB MYP unit plans',
    'IB DP course planning',
    'Early years IB planning',
    'Primary school IB resources',
    'Secondary IB lesson plans',
    'IB teacher planning tools',
    'International kindergarten plans',
    'IB elementary resources',
    'IB high school planning',
    'IB planner templates',
    'Global teaching platform',
    'International education software',
    "Explain Like I'm 5!",
    'Photo Booth',
    'PPT Maker',
    'Learning Competency',
    'Unpacking Learning Competency',
    'IPlan',
    'IPlan Objectives',
    'Multi-Grade Lesson Plan',
    'Generic Unpacking',
    'Daily Lesson Log',
    'Summative Test',
    'Topic Explorer',
    'ai',
    'ai Lesson plan',
    'ai Lesson plan generator',
    'ai Lesson plan maker',
    'ai Lesson plan creator',
  ],
};
